import { useLang } from 'hooks/lang';

import { FullProjectIssue, actions } from 'entities';
import { useRouteParams } from 'routes';

import { Button } from 'components/Blocks';
import { CirclePlusIcon } from 'components/Icons';

import { OTHER } from '../utils';
import { getLocalDateString } from 'utils/date';

import { IssueCreationForm } from './types';

interface ExecuteCreationProps {
  children?: never;
  state: IssueCreationForm;
  close: () => void;
  registerNewIssue: (newIssue: FullProjectIssue) => void;
}

function validateFilling({
  actions,
  description,
  name,
  other,
  subType,
  startDate,
}: IssueCreationForm): boolean {
  const ok = [
    subType === OTHER ? !!other?.trim() : true,
    description.trim(),
    name.trim(),
    actions.every(({ action, other: actionOther }) =>
      action === OTHER ? !!actionOther?.trim() : true,
    ),
    startDate,
  ].every(Boolean);

  return ok;
}

export function CreateIssueButton({ state, close, registerNewIssue }: ExecuteCreationProps) {
  const { t } = useLang();

  const { projectId } = useRouteParams('projectProfile');

  const formOk = validateFilling(state);

  const createIssue = actions.projects.createIssue.use({
    block: !formOk,

    params: {
      ...state,
      project: projectId,
      startDate: state.startDate
        ? getLocalDateString(state.startDate, { accountTimezone: true })
        : '',
    },

    onSuccess: (issue) => {
      registerNewIssue(issue);

      close();
    },
  });

  return (
    <Button disabled={!formOk} {...createIssue.buttonProps}>
      <CirclePlusIcon />
      {t('register-issue')}
    </Button>
  );
}
